/** @jsx jsx */
import type { ReactNode } from 'react';
import type { WithDataAttributeProp } from '@balance-web/core';
import { jsx } from '@balance-web/core';
import { Inline } from '@balance-web/inline';
import { useTheme } from '@balance-web/theme';

export type HeaderProps = WithDataAttributeProp<{
  children: ReactNode;
}>;

export const Header = ({ children, data }: HeaderProps) => {
  const { semantic, borderWidth } = useTheme();
  return (
    <Inline
      alignY="center"
      css={{
        borderBottom: `${borderWidth.standard} solid ${semantic.colour.surface.neutral.border}`,
      }}
      data={data}
      paddingX="large"
      paddingY="medium"
    >
      {children}
    </Inline>
  );
};
